import React, { useContext, useEffect } from "react";
import Element from "../elements/Element";
import sortElements from "../elements/sortElements.js";
import { VariantContextData } from "../variants/VariantBuilderContext";
import FlexSectionColumnSpacingHandle from "./FlexSectionColumnSpacingHandle";
import arePropsEqual from "../../utils/arePropsEqual";
import { buildFlexSectionColumnStylesheet } from "./FlexSectionColumnStyleResolver";

const FlexSectionColumn = (props) => {
  const section = props.section;
  const section_column = props.section_column;
  const column = props.column;
  const structure = section_column.options || {};

  let contextData;
  if (props.builder == true) {
    [contextData] = useContext(VariantContextData);
  }

  const showBuilderSpacingHandles =
    props.builder == true &&
    contextData.selected_object_type == "section_columns" &&
    contextData.selected_object_id == section_column.id;

  const customClass = structure["custom-class"] || "";
  const hideDesktopClass =
    structure["hide-desktop"] === "true" ? "cf-hide-desktop" : "";
  const hideMobileClass =
    structure["hide-mobile"] === "true" ? "cf-hide-mobile" : "";

  const hasNestedElements =
    props.builder !== true &&
    Object.prototype.hasOwnProperty.call(section_column, "elements");
  const sourceElements = hasNestedElements
    ? section_column.elements
    : Object.values(section.elements || {}).filter(
        (e) => e.section_column_id == section_column.id
      );
  const column_elements = Object.values(sourceElements || {})
    .filter((e) => e.section_id == section.id && e.toBeDeleted !== true)
    .sort((a, b) => a.position - b.position);

  // Click / contextmenu / hover for flex columns are delegated from #builder
  // (objectCanvasDelegation.js) — no per-column listeners here.
  useEffect(() => {
    if (props.builder !== true) return;

    sortElements.start(section, column);
  }, [
    props.builder,
    section.id,
    section_column.id,
    section.element_id,
    column.position,
  ]);

  const stylesheet = buildFlexSectionColumnStylesheet(section, section_column);

  return (
    <div
      className={`cf-col cf-flex-column cf-col-md-12 ${customClass} ${hideDesktopClass} ${hideMobileClass}`}
      column-position={column.name}
      data-column-position={column.name}
      data-section-column-id={section_column.id}
      section-id={section.id}
      data-section-id={section.id}
      data-object-type="section_columns"
      data-object-id={section_column.id}
    >
      <div
        className="cf-background-overlay"
        section-id={section.id}
        data-section-id={section.id}
      ></div>
      <div
        className="cf-cta-item-container"
        section-id={section.id}
        data-section-id={section.id}
        data-sortable-id={column.position}
        data-section-column={column.position}
      >
        <div className="cf-cta-item disabled-item"></div>
        {props.builder == true && (
          <p
            className="cf-draggable-creation-hover empty-container"
            data-object-type="Elements"
          >
            Column: Drag elements here
          </p>
        )}
        {column_elements.map((element) => (
          <Element
            key={`element-${element.id}`}
            builder={props.builder}
            device={props.device}
            website={props.website}
            cta={props.cta}
            variant={props.variant}
            section={props.section}
            element={element}
            preview={props.preview}
          />
        ))}
      </div>
      {props.builder == true && (
        <React.Fragment>
          <div
            className="section-add-element"
            data-section-id={section.id}
            style={{ display: "none" }}
            onClick={() => {
              dispatchCustomEvent("newObject", {
                object_type: "Elements",
                section_id: section.id,
                column: column.position,
                element_type: null,
              });
            }}
          >
            <span
              className="glyphicon glyphicon-plus"
              aria-hidden="true"
              data-section-id={section.id}
            ></span>
          </div>
        </React.Fragment>
      )}
      {showBuilderSpacingHandles && (
        <React.Fragment>
          <FlexSectionColumnSpacingHandle
            key={`section-column-${section_column.id}-spacer-top`}
            section={section}
            section_column={section_column}
            direction="top"
          />
          <FlexSectionColumnSpacingHandle
            key={`section-column-${section_column.id}-spacer-bottom`}
            section={section}
            section_column={section_column}
            direction="bottom"
          />
          <FlexSectionColumnSpacingHandle
            key={`section-column-${section_column.id}-spacer-left`}
            section={section}
            section_column={section_column}
            direction="left"
          />
          <FlexSectionColumnSpacingHandle
            key={`section-column-${section_column.id}-spacer-right`}
            section={section}
            section_column={section_column}
            direction="right"
          />
        </React.Fragment>
      )}
      <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
    </div>
  );
};

export default React.memo(FlexSectionColumn, arePropsEqual);
